<template>
  <div>
    <Header :title="'在线纪念'" />
    <div class="container" :class="type === 2? 'open' : ''">
      <div class="top">
        <div class="tab-head">
          <div class="col-3" :class="[tabIndex===0?'active':'']" @click="tabClick(0)">祭祀记录</div>
          <div class="col-3" :class="[tabIndex===1?'active':'']" @click="tabClick(1)">日排行</div>
          <div class="col-3" :class="[tabIndex===2?'active':'']" @click="tabClick(2)">月排行</div>
        </div>
        <!-- <div class="title">祭祀记录</div> -->
        <div class="work">
          <!-- <span v-show="type === 1" @click="toggleType(2)">管理</span> -->
          <!-- <span v-show="type === 2" @click="toggleType(1)">完成</span> -->
        </div>
      </div>
      <!-- 祭祀记录 -->
      <div v-show="tabIndex === 0" class="records">
        <div class="main">
          <div class="main-list">
            <div v-for="item of recordList" :key="item.id" class="main-item">
              <div class="itemBox flex-column-between-center">
                <div class="avator-box">
                  <img :src="$resUrl(item.picturePath)" alt>
                </div>
                <div class="name text-hide">{{ item.name }}</div>
                <div class="person text-hide">
                  <span>敬献人：</span>
                  <span>{{ item.offerName }}</span>
                </div>
                <div class="status text-hide">
                  <span v-show="item.isOverdue" class="red">已过期</span>
                  <span v-show="!item.isOverdue">{{ item.surplusTime }}</span>
                </div>
                <div v-show="power !== 3 || !item.isHide" class="btn" @click="openDetail(item)">详情</div>
                <div
                  v-show="power === 3 && item.isHide"
                  class="btn btn-show"
                  @click="doShow(item)"
                >显示</div>
              </div>
              <!-- <div class="checkBox" v-show="type === 2">
              <nut-checkbox v-model="item.myChecked" @change="getChange(item)"></nut-checkbox>
              </div>-->
            </div>
          </div>
        </div>
        <!-- 分页 -->
        <div v-show="recordList.length" class="pagination">
          <van-pagination
            v-model="pageIndex"
            :total-items="total"
            :show-page-size="3"
            :items-per-page="pageSize"
            force-ellipses
            @change="pageChange"
          />
        </div>
        <div v-if="!recordList.length" class="noData">暂无数据</div>
      </div>
      <!-- 日排行 -->
      <div v-show="tabIndex === 1" class="rankDay">
        <rank-record :list="DayRank" />
      </div>
      <!-- 月排行 -->
      <div v-show="tabIndex === 2" class="rankMonth">
        <rank-record :list="MonthRank" />
      </div>
    </div>
    <!-- <div class="actions" v-show="type === 2">
      <div class="left">
        <nut-button>移动</nut-button>
        <nut-button>隐藏</nut-button>
      </div>
      <div class="right">
        <nut-button>删除</nut-button>
      </div>
    </div>-->
    <!-- 敬献详情弹出层 -->
    <nut-popup v-model="showDetail">
      <record-detail :detail-info="detail" @close="closeDetail" />
    </nut-popup>
    <Footer :active="4" />
  </div>
</template>

<script>
import Vue from 'vue'
import { Pagination } from 'vant'
import { GetSacrifices, CheckPower, ShowSacrifice, GetRanking } from '@/api/Hall/index'
import { Toast } from '@nutui/nutui'
import Header from '@/components/Header/Index'
import Footer from './components/Footer'
import RecordDetail from './components/RecordDetail'
import RankRecord from './components/RankRecord'

Vue.use(Pagination)

export default {
  name: 'SacrificeRecord',
  components: {
    Header,
    Footer,
    RecordDetail,
    RankRecord
  },
  data() {
    return {
      id: '',
      recordList: [],
      pageIndex: 1,
      pageSize: 12,
      total: 0,
      type: 1, // 1为正常模式，只可看，2为管理模式，可操作
      checkList: [], // 选中的祭祀记录id列表
      showDetail: false,
      detail: {},
      power: 0, // 1未登录，2登录人无权限，3登录人有权限
      tabIndex: 0,
      DayRank: [],
      MonthRank: []
    }
  },
  mounted() {
    this.id = this.$route.params.id
    this.JudgePower()
    this.getList()
    this.Ranking()
  },
  methods: {
    tabClick(i) {
      this.tabIndex = i
    },
    Ranking() {
      GetRanking(this.id).then(res => {
        this.DayRank = res.data.dayRecord
        this.MonthRank = res.data.monthRecord
      })
    },
    getList() {
      const params = {
        id: this.id,
        mt: 0,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      GetSacrifices(params).then(res => {
        this.total = res.data.total
        res.data.rows.forEach(item => {
          item.myChecked = false
        })
        this.recordList = res.data.rows
      })
    },
    JudgePower() {
      const hallId = this.$route.params.id
      CheckPower(hallId).then(res => {
        if (res.data.desc === '请先登录') {
          this.power = 1
        }
        if (res.data.desc === '没有权限') {
          this.power = 2
        }
        if (res.data.desc === '有权限') {
          this.power = 3
        }
      })
    },
    doShow(item) {
      const id = item.id
      ShowSacrifice(id).then(res => {
        Toast.success('显示成功！')
        this.getList()
      })
    },
    closeDetail() {
      this.showDetail = false
    },
    pageChange() {
      this.getList()
    },
    toggleType(i) {
      this.type = i
    },
    openDetail(item) {
      this.showDetail = true
      this.detail = item
    },
    getChange(item) {
      this.checkList = []
      this.recordList.forEach(item => {
        if (item.myChecked) {
          this.checkList.push(item.sacrificesGoodsId)
        }
      })
      // console.log(this.checkList, 'checkList')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 0px 15px 63px 15px;

  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0px;

    .tab-head {
      width: 100%;
      height: 40px;
      line-height: 40px;
      position: relative;
      box-sizing: border-box;
      overflow: hidden;

      .col-3 {
        width: 33.33%;
        height: 40px;
        float: left;
        position: relative;
        text-align: center;
        box-sizing: border-box;
        color: #4d4d4d;
        border-bottom: 2px solid #cccccc;
        font-size: 16px;
        font-weight: 600;

        &.active {
          color: #eea105;
          border-bottom: 2px solid #eea105;
        }
      }
    }

    .title {
      font-size: 20px;
      color: #333;
      font-weight: bold;
    }

    .work {
      font-size: 15px;
    }
  }
  .records {
    .main {
      .main-list {
        display: flex;
        flex-wrap: wrap;

        .main-item {
          position: relative;
          width: 108px;
          height: 140px;
          margin-right: 10px;
          margin-bottom: 10px;
          background: #fff;
          border-radius: 8px;
          box-shadow: 0px 0px 5px 5px #efeeed;

          .itemBox {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            padding: 6px 0px;
            font-size: 12px;

            .avator-box {
              width: 51px;
              height: 51px;
              background: url('~@/assets/images/record-avator-bg.png');
              background-size: 100% 100%;
              display: flex;
              justify-content: center;
              align-items: center;

              img {
                width: 85%;
                height: 85%;
              }
            }

            .name {
              color: #353535;
              font-weight: bold;
            }

            .person {
              color: #5c5c5c;
            }

            .status {
              color: #808080;

              .red {
                color: #e41a1a;
              }
            }

            .text-hide {
              padding: 0px 10px;
              width: 100%;
              text-align: center;
              box-sizing: border-box;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .btn {
              width: 35px;
              height: 16px;
              line-height: 18px;
              text-align: center;
              border-radius: 2px;
              background: #e8e5df;
              color: #9d9b9b;
            }
            .btn-show {
              background: $primary-color;
              color: #fff;
            }
          }

          .checkBox {
            position: absolute;
            top: -5px;
            right: -5px;
            z-index: 20;

            .nut-checkbox {
              margin-right: 0px;

              ::v-deep input {
                border: 1px solid #ddd;
                background-color: #fff;
                border-radius: 50%;
              }

              ::v-deep input:checked {
                background-color: $primary-color;
              }
            }
          }
        }

        .main-item:nth-child(3n) {
          margin-right: 0px;
        }
      }
    }

    .pagination {
      padding: 15px;

      .van-pagination {
        margin-bottom: 10px;
        justify-content: center;

        ::v-deep .van-pagination__item {
          color: #555;
          border-radius: 5px;
          margin: 0 3px;
          font-weight: bold;
          height: 35px;
        }

        ::v-deep .van-pagination__item::after {
          display: none;
        }

        ::v-deep .van-pagination__item:disabled {
          background: #fff;
          opacity: 1;
          color: #ddd;
        }

        ::v-deep .van-pagination__item:active {
          background-color: $primary-color-bright;
          color: #fff;
        }

        ::v-deep .van-pagination__item--disabled {
          background: #fff;
          opacity: 1;
          color: #ddd;
        }

        ::v-deep .van-pagination__item--active {
          background-color: #fff;
          color: $primary-color;
        }

        ::v-deep .van-pagination__prev {
          max-width: 150px;
        }

        ::v-deep .van-pagination__next {
          max-width: 150px;
        }
      }
    }
    .noData {
      text-align: center;
      color: #bbb;
    }
  }
}

.open {
  padding-bottom: 75px;
}

.actions {
  position: fixed;
  width: 100%;
  bottom: 50px;
  height: 49px;
  line-height: 49px;
  display: flex;
  padding: 0px 15px;
  box-sizing: border-box;
  justify-content: space-between;
  background: #fff;
  box-shadow: 0px 5px 6px 10px #edecec;

  .left {
    .nut-button {
      width: 68px;
      height: 27px;
      padding: 0px;
      line-height: 27px;
      margin-right: 15px;
      background: $primary-color;
      border-radius: 3px;
    }
  }

  .right {
    .nut-button {
      width: 100px;
      height: 35px;
      padding: 0px;
      line-height: 35px;
      background: $primary-color;
      border-radius: 18px;
    }
  }
}

.popup-box {
  width: 86vw;
  height: 250px;
  border-radius: 10px;
}
</style>
